<template>
    <section>
        <h5>Instruções para denúncia</h5>

        <div class="row">
            <div class="col-12">
                <strong>1 -</strong> Os campos de informações pessoais, não são de preenchimento obrigatório.
            </div>
            
            <div class="col-12">
                <strong>2 -</strong> Os campos com <span class="obrigatorio">*</span> (asterisco), são de preenchimento obrigatório.
            </div>
            
            <div class="col-12">
                <strong>3 -</strong> Arquivos de áudio, vídeo e imagem podem ser anexados no botão anexar (Máx 100mb).
            </div>
            
            <div class="col-12">
                <strong>4 -</strong> A denúncia deverá conter o máximo de informação possível.
            </div>
            
            <div class="col-12">
                <strong>5 -</strong> Ao final será gerado um protocolo que permitirá consultar o andamento de sua denúncia e complementar a mesma.
            </div>
        </div>

        <hr>

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label>Nome completo</label>
                    <input type="text" class="form-control form-control-sm" v-model="denunciante.nome">
                </div>
            </div>

            <div class="col-md-6">
                <div class="form-group">
                    <label>Telefone</label>
                    <input type="text" class="form-control form-control-sm" v-model.number="denunciante.telefone" v-mask="['(##) ####-####', '(##) #####-####']">
                </div>
            </div>

            <div class="col-md-6">
                <div class="form-group">
                    <label>Email</label>
                    <input type="text" class="form-control form-control-sm" v-model="denunciante.email">
                </div>
            </div>

            <div class="col-md-6">
                <div class="form-group">
                    <label>Logradouro</label>
                    <input type="text" class="form-control form-control-sm" v-model="denunciante.logradouro">
                </div>
            </div>

            <div class="col-md-4">
                <div class="form-group">
                    <label>Município</label>
                    <input type="text" class="form-control form-control-sm" v-model="denunciante.municipio">
                </div>
            </div>

            <div class="col-md-2">
                <div class="form-group">
                    <label>UF</label>
                    <input type="text" class="form-control form-control-sm" v-model="denunciante.uf">
                </div>
            </div>
        </div>

        <hr>

        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <label>Local do ocorrido <span class="obrigatorio">*</span></label>
                    <input type="text" class="form-control form-control-sm" v-model="denuncia.local">
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group">
                    <label>Tipo de denúncia <span class="obrigatorio">*</span></label>
                    <select class="form-control form-control-sm" v-model="denuncia.type">
                        <option v-for="type in denuncia_type" :value="type.id" :key="type.id">{{ type.nome }}</option>
                    </select>
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group">
                    <label>Data <span class="obrigatorio">*</span></label>
                    <input type="date" class="form-control form-control-sm" v-model="denuncia.data">
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group">
                    <label>Hora <span class="obrigatorio">*</span></label>
                    <input type="time" class="form-control form-control-sm" v-model="denuncia.hora">
                </div>
            </div>

            <div class="col-12">
                <div class="form-group">
                    <label>Denúncia <span class="obrigatorio">*</span></label>
                    <textarea cols="100" rows="10" class=form-control v-model="denuncia.denuncia"></textarea>
                </div>
            </div>
        </div>

        <transition mode="out-in" name="leftIn">
            <div v-if="anexos[0]" class="row">
                <div class="col-12">
                    <p><strong>Anexos</strong></p>
                </div>

                <div v-for="(file, index) in anexos" :key="index" class="col-12">
                    <div class="d-flex justify-content-between">
                        <p class="p-1">{{ file.name }}</p>

                        <span class="p-1 pointer" @click="rm_file(index)">
                            <font-awesome-icon icon="times" />
                        </span>
                    </div>
                </div>
            </div>
        </transition>

        <input type="file" @change="add_file" id="files" class="hidden" multiple>

        <hr>

        <div v-if="uploading" class="text-center mb-3">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Enviando anexos...</span>
            </div>
            <p>Enviando anexos, por favor, aguarde...</p>
        </div>

        <div class="d-flex justify-content-end">
            <button @click="enviar" class="btn btn-sm btn-light ml-2">Enviar</button>

            <button class="btn btn-sm btn-light ml-2" onclick="$('#files').trigger('click')">
                <font-awesome-icon icon="paperclip" size="xs" /> Anexar
            </button>

            <button @click="clear_form" class="btn btn-sm btn-light ml-2">Limpar formulário</button>
            <router-link :to="{ name: 'den_index' }" class="btn btn-sm btn-light ml-2">Voltar</router-link>
        </div>

        <modal-alert :message="alert_message" />
        <modal-confirm :message="confirm_message" @response="confirm_response" />
    </section>
</template>

<script>
    import api from '@/mixins/api.js'

    export default {
        name: "Nova-denuncia",
        mixins: [ api ],

        data() { 
            return {
                confirm_message: "",
                alert_message: "",

                denunciante: {
                    nome: "",
                    email: "",
                    telefone: "",
                    municipio: "",
                    logradouro: "",
                    uf: "",
                },

                denuncia: {},
                anexos: [],
                denuncia_type:{},
                uploading: false, 
            }
        },

		mounted() {
			this.load_denuncia_type();
		},

        methods: {
            enviar() {
                if ( this.denuncia.local && this.denuncia.type && this.denuncia.data && this.denuncia.hora && this.denuncia.denuncia ){
                    this.submit();
                }else {
                    this.alert_message = "Preencha os campos obrigatórios!";
                    $("#modal-alert").modal();
                }
            },

            async submit() {
                const data = {
                    denunciante: this.denunciante,
                    denuncia: this.denuncia,
                    anexos: this.anexos
                }
                data.denuncia.canal = 2;

                const response = await this.POST("Webform/Denuncia", data);

                if ( response.status === 'success' ) {
                    await this.submit_anexos(response.denuncia_id, response.protocolo);
                    if (this.uploading == false)
                        this.$router.push({ name: "den_protocolo", params: { protocolo: response.protocolo } });
                }else {
                    this.alert_message = response;
                    $("#modal-alert").modal();
                }
            },
            
            async load_denuncia_type() {
                const response = await this.GET('Webform/DenType');

                if(response.status == 'success'){
                    this.denuncia_type = response.result;
                }
			},

            async submit_anexos(den, protocolo) {
                this.uploading = true;

                this.anexos.forEach( async file => {
                    let body = new FormData()
                    body.append('attachment', file)
                    body.append('nome', file.name)
                    body.append('type', file.type)
                    
                    const response = await this.POST(`Webform/Attachment/${den}`, body)

                    if (response.status !== 'success') {
                        this.alert_message = `Erro ao enviar o anexo: ${file.name}`;
                        $("#modal-alert").modal();
                    }
		    else
			{
			 this.uploading = false;
			 this.$router.push({ name: "den_protocolo", params: { protocolo: protocolo } });
			}
                })
            },

            add_file(event) {
                const files = Array.from(event.target.files);
                files.forEach(element => this.anexos.push(element) );
            },

            rm_file(payload) {
                this.anexos.splice(payload, 1);
            },

            clear_form() {
                this.confirm_message = "Isto limpará todos os dados inseridos no formulário. Continuar?";
                $("#modal-confirm").modal();
            },

            confirm_response(response) {
                if ( response === 1) {
                    this.denunciante = {
                        nome: "",
                        email: "",
                        telefone: "",
                        municipio: "",
                        logradouro: "",
                        uf: "",
                    }

                    this.denuncia = {}
                    this.anexos = []
                }
            },
        },
    }
</script>

<style>
    .obrigatorio {
        color: brown;
    }
</style>
